import "bootstrap/dist/css/bootstrap.css";

import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./Core/App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

// Get the application-wide store instance, prepopulating with state from the server where available.//
//const store = configureStore(history);

ReactDOM.render(<App />, document.getElementById("root"));

// registerServiceWorker();
unregisterServiceWorker();
